import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services';

/**
 * Catches HTTP errors, if the HTTP status code is 401, log out the user.
 */
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private httpNotAuthorized: number = 401;
  constructor(private authenticationService: AuthenticationService, private router: Router) {}

  /**
   * If HTTP status code is 401, log out the user otherwise throw an error.
   */
  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError((err: HttpErrorResponse) => {
      if (err.status === this.httpNotAuthorized && this.router.url.indexOf('login') < 0) {
        this.authenticationService.logout();
        location.reload();
      }

      return throwError(err);
    }));
  }
}
